import { memo, useEffect, useState } from 'react';
import { CustomTooltip } from '../tooltip';
import { QuotesImage, InfoIcon } from '../utils/svg-icon';
import "./quote.css";

export const Quote = memo(({ quoteInfo, partnerGuid, logo, ...props }) => {
  const [annualLimit, setAnnualLimit] = useState('');

  useEffect(() => {
    const plans = quoteInfo?.Plans;
    if (plans) {
      const plan = plans.filter((item) => item.Plan === quoteInfo.Plan);
      if (plan.length > 0) {
        setAnnualLimit(plan[0].MaxAnnual)
      }
    }
  }, [quoteInfo]);

  const handleButtonClick = () => {
    const { petType, gender, email, zipCode, groupCode, groupCodeDscr, utmSource, utmMedium, utmCampaign } = props;
    window.open(`${process.env.REACT_APP_QUOTE_REDIRECT_URL}/quoting/getquote?PetName=${quoteInfo.PetName}&PetType=${petType}&PetSex=${gender}`
      + `&PetBreed=${quoteInfo.BreedName}&PetAge=${quoteInfo.PetAgeName}&PetZipCode=${zipCode}&GroupCode=${groupCode}`
      + `&email=${email}&GroupCodeDscr=${groupCodeDscr}&plan=${quoteInfo.PlanName}&reimbursement=${quoteInfo.ReimbursementName}&deductible=${quoteInfo.DeductibleName}`
      + `${partnerGuid ? `&partnerGuid=${partnerGuid}` : ''}`
      + `&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`,
      '_blank'
    )
  }

  return (
    <main
      className={'ui-quote-container'
        + `${logo ? ' ui-widget-container-partner' : ''}`
      }
    >
      {logo && <img alt="costco" className="ui-partner-logo" src={logo} />}
      <div className='ui-quote-text' data-ispartner={!!logo}>
        <p className='heading'>{`${quoteInfo.PetName}'s`} Figo Plan</p>
        <p className='info'>Design your pet’s plan in less than 60 seconds</p>
        {!logo && <QuotesImage />}
      </div>
      <div className='ui-quote-main'>
        <div>
          <p className='heading main-heading'>Figo’s <span>Most Popular</span> Pet Plan</p>
        </div>
        <div className='ui-quote-monthly-premium'>
          <sup className=''>$</sup>
          <span className='price'>{Number(quoteInfo.MonthlyPremium).toFixed(2)}</span>
          <sup className='per-month'>/mo</sup>
        </div>
        <div className='ui-quote-details'>
          <div className='ui-quote-detail'>
            <p className='title'>Annual Limit
              <CustomTooltip
                overLayText='The amount of approved vet medical costs that you can be reimbursed for annually.'
                icon={<InfoIcon />}
              >
              </CustomTooltip>
            </p>
            <p className='price'>{annualLimit}</p>
          </div>
          <div className='ui-quote-detail'>
            <p className='title'>Reimbursement
              <CustomTooltip
                overLayText="The percentage of covered expenses that you'll be reimbursed for after you hit your deductible."
                icon={<InfoIcon />}
              >
              </CustomTooltip>
            </p>
            <p className='price'>{quoteInfo.ReimbursementName}</p>
          </div>
          <div className='ui-quote-detail'>
            <p className='title'>Deductible
              <CustomTooltip
                overLayText='The annual amount you pay for treatments covered by your policy before Figo will begin to reimburse you.'
                icon={<InfoIcon />}
              >
              </CustomTooltip>
            </p>
            <p className='price'>{quoteInfo.DeductibleName}</p>
          </div>
        </div>
        <div className='ui-quote-btn-wrapper'>
          <button className='ui-quote-btn' onClick={handleButtonClick}>
            Show Quote Details
          </button>
        </div>
      </div>
    </main>
  )
})
